import { makeStyles } from 'tss-react/mui';

interface Options {
  containerWidth: number;
  containerHight: number;
  iconWidth: number;
}

export const useStyles = makeStyles<Options>()(
  (theme, { containerHight, containerWidth, iconWidth }) => ({
    root: {
      backgroundColor: '#3d3f5e',
      width: theme.spacing(containerWidth),
      height: theme.spacing(containerHight),
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      marginRight: theme.spacing(1.25),
    },

    activeIcon: {
      backgroundColor: theme.palette.primary.light,
    },

    icon: {
      width: theme.spacing(iconWidth),
      objectFit: 'contain',
      margin: 'auto',
      color: 'white',
    },
  })
);
